<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <!-- <li><a class="a_disabled">协会工作部</a></li> -->
                <li><router-link :to="titleLink">{{ title }}</router-link></li>
                <li class="currentNode"><a>主要职责</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>{{ title }}</a></li>
                    <li><router-link :to="`/layout/info-branch-introduction?id=${id}`">工作部简介</router-link></li>
                    <li><router-link :to="`/layout/info-branch-responsibilities?id=${id}`"  class="active">主要职责</router-link></li>

                </ul>
                <div class="page-content">
                    <h3>主要职责</h3>
                    <div class="noContentDetail" v-html="position" ></div>
                    <!-- <p>（一）研究和探讨本市勘察设计行业改革和发展的理论、方针、政策，接受政府和国家行业协会委托的专题调研;向政府有关部门提出企业经营与发展动态和行业管理相关政策的建议:</p>
                    <p>（二）开展行业基本情况调查，协助行业管理部门制定和实施行业发展规划和有关法规，协调执行中出现的问题，注重提高行业整体素质，发挥勘察设计在工程建设领域的灵魂作用;</p>
                    <p>（三）反映企业诉求，反映涉及行业利益的事项，积极做好维权工作;</p>
                    <p>（四）建立行业自律机制，制订并组织实施本行业的行规行约，推动行业诚信建设，完善诚信评价体系，向社会推荐优秀诚信企业;</p>
                    <p>（五）参与制定行业的技术标准和规范，倡导科技创新，推动科技进步和工程创优，组织评比市级优秀工程，推荐国家、行业优秀工程;开展优秀勘察设计人员的评选、推荐和表彰工作;</p>
                    <p>（六）组织市场拓展，发布市场信息，推介行业产品和服务，开展行业统计，出具行业证明文件，促进企业同国内外的交流与合作，办好勘察设计刊物及网站，保障信息畅通、准确、公正。</p> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getXiehuiModel,
} from '@services/indexService.js'
export default {
    name:'',
    data() {
        return {
            id: '',
            title: '',
            position: '',
            titleLink: '',
        }
    },
    created() {
        this.id = this.$route.query.id;
        this.traverseTitle();
        this.getXiehuiModel();
    },
    methods: {
        traverseTitle() {
            if (this.id === '1'){
                this.title = "信息工作部";
                this.titleLink = '/layout/info-branch-introduction?id=1';
            } else if (this.id === '2'){
                this.title = "双招双引工作部";
                this.titleLink = '/layout/info-branch-introduction?id=2';
            } else if (this.id === '3') {
                this.title = "医药卫生工作部";
                this.titleLink = '/layout/info-branch-introduction?id=3';
            } else {
                this.title = "企业工作部";
                this.titleLink = '/layout/info-branch-introduction?id=4';
            }
        },
        getXiehuiModel() {
            let params = {
                id: this.id
            };
            getXiehuiModel(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.position = res.Data.Position;
                } else {
                    this.saler = '';
                    this.$message.error("主要职责请求失败");
                }
            })
        },
    },
    watch: {
        // 监听路由对象中的变化
        '$route': {
            handler: function(to, from) {
                // 当路由发生变化时会调用这个函数
                // to 和 from 分别代表到达的路由和离开的路由
                this.id = to.query.id + '';
                this.traverseTitle();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        },
        '$route.query.id': {
            handler: function(toId, fromId){
                this.id = toId;
                this.getXiehuiModel();
                this.traverseTitle();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        },
    }
}
</script>

<style scoped>
.page-content {
    padding: 30px;
}
.page-content h3{
    text-align:center;
}
.page-content p {
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 28.64px;
    color: #4E5969;
    margin-bottom: 20px;
    width: 100%;
    text-indent: 2em;
}
.a_disabled {
    cursor: not-allowed;
}
</style>